import api from '../configuration/ApiConfig'
const servicesService={
GetServiceByServiceName:(id)=>{
    const request = api.get('Services/GetServiceById?id='+id)
    return request.then((response)=>{
        return response.data
    })
}
}
export default servicesService; 